import { Minimize2 } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const MinimizeIcon = createLucideIcon(Minimize2);
